import ButtonsFixed, { SpaceButtons } from '@ui/buttons/ButtonsFixed'
import Page from '@shell/Page'
import { router } from 'expo-router'
import { useLogout } from 'hooks/useLogout'
import { useCustomer, useStaff } from 'hooks/useSession'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

import { useIsFocused } from '@ui/hooks/useIsFocused'
import { useIsNavigationReady } from 'hooks/useIsNavigationReady'
import CreateAccount from './sections/CreateAccount'
import Customers from './sections/Customers'
import InfoStore from './sections/InfoStore'
import QuickLogin from './sections/QuickLogin'
import Chat from './sections/Chat'
import { trpc } from 'api/trpc'

export default function StaffPanel() {
  const { t } = useTranslation()

  const customer = useCustomer()
  const staff = useStaff()
  const logout = useLogout({
    navigate: true,
  })
  const focused = useIsFocused()
  const isNavigationReady = useIsNavigationReady()

  useEffect(() => {
    if (!isNavigationReady || !focused) return
    if (!staff) {
      logout()
    }
  }, [staff, logout, isNavigationReady, focused])

  const handleBack = () => {
    if (router.canGoBack()) {
      router.back()
      return
    }
    router.navigate('/')
  }

  const { data, isLoading: isLoadingCustomers } =
    trpc.customer.quickLogin.list.useQuery({
      limit: 1,
    })

  const hasQuickLogin = data && data.data.length > 0

  return (
    <>
      <Page validateStaff stage="staff" back={handleBack}>
        <View className="gap-8 p-8 pt-0">
          <InfoStore />
          <Customers />
          <View className="w-full flex-row gap-8">
            <QuickLogin />
            <CreateAccount />
          </View>
          <Chat />
          {customer && <SpaceButtons />}
        </View>
      </Page>
      {!customer && !hasQuickLogin && (
        <ButtonsFixed
          buttons={[
            {
              label: t('staff:customers.header.title'),
              variant: 'filled',
              iconEnd: 'arrow-right',
              onPress: () => router.navigate('/staff/customers'),
              loading: isLoadingCustomers,
            },
          ]}
        />
      )}
      {!customer && hasQuickLogin && (
        <ButtonsFixed
          buttons={[
            {
              label: t('staff:quickLogin.header.title'),
              variant: 'outlined',
              iconEnd: 'arrow-right',
              onPress: () => router.navigate('/staff/quick-login'),
            },
          ]}
        />
      )}
      {customer && (
        <ButtonsFixed
          buttons={[
            {
              label: t('ui:stage.customer'),
              variant: 'outlined',
              iconStart: 'arrow-left',
              onPress: () => router.navigate('/customer/home'),
            },
          ]}
        />
      )}
    </>
  )
}
